module.exports = __webpack_public_path__ + "media/react-calc.5f6dac56.mp4";